  (function($){

    var c = {
      init: function(){
        if( $(".remove-user-from-entity").length == 0 ){ return false; }
        $(".remove-user-from-entity").click(c.removeUser);
      },
      removeUser: function(ev){
        ev.preventDefault();
        var context = $(this);
        $.ajax({
          url: "/ajax/remove_user_from_entity",
          data: {
            entity_class: context.data("entity"),
            entity_id: context.data("id"),
            user_email: context.data("email")
          },
          success: function(){
            location.reload();
          }
        });
      }
    };

    c.init();

  })(jQuery);
